// Catalogo/CompraLicencias.jsx
export default function CompraLicencias() {
  return <div>Vista: Comprar licencias</div>;
}
